import { render, staticRenderFns } from "./oncall-by-person.vue?vue&type=template&id=d74382ba&"
import script from "./oncall-by-person.vue?vue&type=script&lang=ts&"
export * from "./oncall-by-person.vue?vue&type=script&lang=ts&"
import style0 from "./oncall-by-person.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports